import Profile from "views/Account/Profile.jsx";
import UpdatePassword from "views/Account/UpdatePassword.jsx";
import { gisRoutes } from "./routes";
import phrasebookLoad from "../i18n";
import DashboardRoutes from "./dashboards.jsx";
import {
  Accounts,
  AccountAdd,
  AccountEdit,
  MasterAdd,
} from "../views/Account/Account/Account";
import {
  Customers,
  CustomerAdd,
  CustomerAddMaster,
  CustomerBulk,
  CustomerEdit,
} from "../views/Account/Account/Customer";
import { Functionalities } from "../views/Administration/Functionality";
import {
  Permissions,
  PermissionsAdd,
  PermissionsEdit,
} from "../views/Administration/Permission";
import {
  NotificationTypes,
  NotificationTypesAdd,
  NotificationTypesEdit,
} from "../views/Administration/NotificationType";
import { Orders, OrderShow } from "../views/Management/Order";
import OrderEditProcess from "../views/Management/Order/OrderEdit/index";
import OrderAddProcess from "../views/Management/Order/OrderAdd/index";
import {
  Vendors,
  VendorBulk,
  VendorAdd,
  VendorEdit,
} from "../views/Account/Account/Vendor";
import {
  ServiceNumberCoverageType,
  ServiceNumberCoverage,
} from "../views/Management/ServiceNumberCoverage";
import {
  ServiceNumberType,
  ServiceNumberTypeAdd,
  ServiceNumberTypeEdit,
  ServiceNumberTypeBulk,
} from "../views/Management/ServiceNumberType";

import {
  InvNumber,
  InvNumberAdd,
  InvNumberShow,
  InvNumberBulk,
} from "../views/Management/Invnumber";

import {
  Carrier,
  CarrierBulk,
} from "../views/Management/Carrier";

import { Notifications, NotificationRead } from "../views/Notification";
import { Downloads } from "../views/Download";

import { Contacts, Tickets, AddTicket } from "../views/Support";
import { SummaryOverview, CallStatistics, CallRecords, CallStatisticsH } from "../views/Report";
import ConfigurationEdit from "../views/Administration/Configuration/ConfigurationEdit.jsx"
import WorkInProgress from "../views/Account/WorkInProgress.jsx";

import {
  portalFunctionalityConstants,
  permissionTypeConst,
} from "../constants";
const phrasebook = phrasebookLoad();

const ORDER_ON = process.env.REACT_APP_ENABLE_ORDER;
const REPORT_ON = process.env.REACT_APP_ENABLE_REPORTING;



/**
 * @path available paths on the portal/landing page
 * @component main page that links to the path (available in views folder)
 * @routeType route type is to check whether the routes is coming from account or portal
 * @type link type(logo, link, icon)
 * @name name to display on the link
 */
const portalRoutes = [
  {
    path: gisRoutes.account.profile,
    component: Profile,
    routeType: "portal",
    type: "icon",
    category: "profile",
    name: phrasebook.profile.profile,
  },
  {
    path: gisRoutes.account.update_password,
    component: UpdatePassword,
    routeType: "portal",
    type: "icon",
    category: "profile",
    name: phrasebook.profile.update_password,
  },
  {
    path: gisRoutes.account.account.add,
    component: AccountAdd,
    routeType: "portal",
    restrictedFunction: portalFunctionalityConstants.account.account,
    action: permissionTypeConst.ADD,
    type: "add",
    name: phrasebook.common.add,
  },
  {
    path: gisRoutes.account.account.edit,
    component: AccountEdit,
    routeType: "portal",
    restrictedFunction: portalFunctionalityConstants.account.account,
    action: permissionTypeConst.EDIT,
    type: "edit",
    name: phrasebook.common.edit,
  },
  {
    path: gisRoutes.account.account.delete,
    routeType: "portal",
    restrictedFunction: portalFunctionalityConstants.account.account,
    action: permissionTypeConst.DELETE,
    type: "delete",
    name: phrasebook.common.delete,
  },
  {
    path: gisRoutes.account.customer.master,
    component: MasterAdd,
    routeType: "portal",
    restrictedFunction: portalFunctionalityConstants.account.customer,
    action: permissionTypeConst.ADD,
    type: "add",
    name: phrasebook.common.add,
  },
  {
    path: gisRoutes.account.customer.add,
    component: CustomerAdd,
    routeType: "portal",
    restrictedFunction: portalFunctionalityConstants.account.customer,
    action: permissionTypeConst.ADD,
    pccwglobal_only: true,
    type: "add",
    name: phrasebook.common.add,
  },

  {
    path: gisRoutes.account.customer.bulk,
    component: CustomerBulk,
    routeType: "portal",
    restrictedFunction: portalFunctionalityConstants.account.customer,
    action: permissionTypeConst.ADD,
    pccwglobal_only: true,
    type: "add",
    name: phrasebook.common.add,
  },
  {
    path: gisRoutes.account.customer.edit,
    component: CustomerEdit,
    routeType: "portal",
    restrictedFunction: portalFunctionalityConstants.account.customer,
    action: permissionTypeConst.EDIT,
    type: "edit",
    name: phrasebook.common.edit,
  },
  {
    path: gisRoutes.account.customer.delete,
    routeType: "portal",
    restrictedFunction: portalFunctionalityConstants.account.customer,
    action: permissionTypeConst.DELETE,
    type: "delete",
    name: phrasebook.common.delete,
  },
  {
    path: gisRoutes.account.customer.from_master,
    component: CustomerAddMaster,
    routeType: "portal",
    restrictedFunction: portalFunctionalityConstants.account.customer,
    action: permissionTypeConst.EDIT,
    type: "edit",
    name: phrasebook.common.edit,
  },
  {
    path: gisRoutes.account.customer.list,
    component: Customers,
    restrictedFunction: portalFunctionalityConstants.account.customer,
    action: permissionTypeConst.EDIT,
    pccwglobal_only: true,
    show_always: true,
    routeType: "portal",
    type: "link",
    category: "account",
    name: phrasebook.headerlinks.customer_details,
  },
  {
    path: gisRoutes.account.account.list,
    component: Accounts,
    restrictedFunction: portalFunctionalityConstants.account.account,
    action: permissionTypeConst.LIST,
    routeType: "portal",
    type: "link",
    category: "account",
    name: phrasebook.headerlinks.account_details,
  },
  // {
  //   path: gisRoutes.administration.functionality.list,
  //   component: WorkInProgress,
  //   restrictedFunction:
  //     portalFunctionalityConstants.administration.functionality,
  //   action: permissionTypeConst.LIST,
  //   pccwglobal_only: true,
  //   routeType: "portal",
  //   type: "link",
  //   category: "administration",
  //   name: phrasebook.headerlinks.functions,
  // },
  {
    path: gisRoutes.administration.permission.add,
    component: PermissionsAdd,
    restrictedFunction: portalFunctionalityConstants.administration.permission,
    action: permissionTypeConst.ADD,
    routeType: "portal",
    type: "add",
    name: phrasebook.common.add,
  },
  {
    path: gisRoutes.administration.permission.edit,
    component: PermissionsEdit,
    restrictedFunction: portalFunctionalityConstants.administration.permission,
    action: permissionTypeConst.EDIT,
    routeType: "portal",
    type: "edit",
    name: phrasebook.common.edit,
  },
  {
    path: gisRoutes.administration.permission.list,
    component: Permissions,
    restrictedFunction: portalFunctionalityConstants.administration.permission,
    action: permissionTypeConst.LIST,
    routeType: "portal",
    type: "link",
    category: "administration",
    name: phrasebook.headerlinks.permissions,
  },
  {
    path: gisRoutes.administration.notification_type.edit,
    component: NotificationTypesEdit,
    restrictedFunction:
      portalFunctionalityConstants.administration.notification_type,
    action: permissionTypeConst.EDIT,
    routeType: "portal",
    type: "edit",
    name: phrasebook.common.edit,
  },
  {
    path: gisRoutes.administration.notification_type.list,
    component: NotificationTypes,
    restrictedFunction:
      portalFunctionalityConstants.administration.notification_type,
    action: permissionTypeConst.EDIT,
    routeType: "portal",
    type: "link",
    category: "administration",
    name: phrasebook.headerlinks.notification_types,
  },
  // {
  //   path: gisRoutes.management.tariff.add,
  //   component: WorkInProgress,
  //   routeType: 'portal',
  //   restrictedFunction: portalFunctionalityConstants.management.tariff,
  //   action: permissionTypeConst.ADD,
  //   type: 'add',
  //   name: phrasebook.common.add
  // },
  // {
  //   path: gisRoutes.management.tariff.edit,
  //   component: WorkInProgress,
  //   routeType: 'portal',
  //   restrictedFunction: portalFunctionalityConstants.management.tariff,
  //   action: permissionTypeConst.EDIT,
  //   type: 'edit',
  //   name: phrasebook.common.edit
  // },
  // {
  //   path: gisRoutes.management.tariff.delete,
  //   routeType: 'portal',
  //   restrictedFunction: portalFunctionalityConstants.management.tariff,
  //   action: permissionTypeConst.DELETE,
  //   type: 'delete',
  //   name: phrasebook.common.delete
  // },
  // {
  //   path: gisRoutes.management.tariff.list,
  //   component: Pricing,
  //   restrictedFunction: portalFunctionalityConstants.management.tariff,
  //   action: permissionTypeConst.LIST,
  //   pccwglobal_only: true,
  //   routeType: 'portal',
  //   type: 'link',
  //   category: 'management',
  //   name: phrasebook.headerlinks.tariff
  // },
  {
    path: gisRoutes.management.vendor.add,
    component: VendorAdd,
    routeType: "portal",
    restrictedFunction: portalFunctionalityConstants.management.vendor,
    action: permissionTypeConst.ADD,
    pccwglobal_only: true,
    type: "add",
    name: phrasebook.common.add,
  },
  {
    path: gisRoutes.management.vendor.bulk,
    component: VendorBulk,
    routeType: "portal",
    restrictedFunction: portalFunctionalityConstants.management.vendor,
    action: permissionTypeConst.ADD,
    pccwglobal_only: true,
    type: "add",
    name: phrasebook.common.add,
  },
  {
    path: gisRoutes.management.vendor.edit,
    component: VendorEdit,
    routeType: "portal",
    restrictedFunction: portalFunctionalityConstants.management.vendor,
    action: permissionTypeConst.EDIT,
    pccwglobal_only: true,
    type: "edit",
    name: phrasebook.common.edit,
  },
  {
    path: gisRoutes.management.vendor.list,
    component: Vendors,
    restrictedFunction: portalFunctionalityConstants.management.vendor,
    action: permissionTypeConst.EDIT,
    pccwglobal_only: true,
    routeType: "portal",
    type: "link",
    category: "management",
    name: phrasebook.headerlinks.vendors,
  },
  {
    path: gisRoutes.management.service_number_coverage.read,
    component: ServiceNumberCoverageType,
    routeType: "portal",
    // restrictedFunction: portalFunctionalityConstants.management.service_number_type,
    // action: permissionTypeConst.READ,
    // customers_only: true,
    type: "read",
    name: phrasebook.common.read,
  },
  {
    path: gisRoutes.management.service_number_coverage.list,
    component: ServiceNumberCoverage,
    // restrictedFunction: portalFunctionalityConstants.management.service_number_type,
    // action: permissionTypeConst.LIST,
    customers_only: true,
    show_always: true,
    routeType: "portal",
    type: "link",
    category: "management",
    name: phrasebook.headerlinks.service_coverage,
  },
  {
    path: gisRoutes.management.service_number_type.add,
    component: ServiceNumberTypeAdd,
    routeType: "portal",
    restrictedFunction:
      portalFunctionalityConstants.management.service_number_type,
    action: permissionTypeConst.ADD,
    pccwglobal_only: true,
    type: "add",
    name: phrasebook.common.add,
  },
  {
    path: gisRoutes.management.service_number_type.bulk,
    component: ServiceNumberTypeBulk,
    routeType: "portal",
    restrictedFunction:
      portalFunctionalityConstants.management.service_number_type,
    action: permissionTypeConst.ADD,
    pccwglobal_only: true,
    type: "add",
    name: phrasebook.common.add,
  },

  {
    path: gisRoutes.management.service_number_type.edit,
    component: ServiceNumberTypeEdit,
    routeType: "portal",
    restrictedFunction:
      portalFunctionalityConstants.management.service_number_type,
    action: permissionTypeConst.EDIT,
    pccwglobal_only: true,
    type: "edit",
    name: phrasebook.common.edit,
  },
  {
    path: gisRoutes.management.service_number_type.delete,
    component: WorkInProgress,
    routeType: "portal",
    restrictedFunction:
      portalFunctionalityConstants.management.service_number_type,
    action: permissionTypeConst.DELETE,
    pccwglobal_only: true,
    type: "delete",
    name: phrasebook.common.delete,
  },
  { // REVIEW THIS PERMISSION AND CHECK IF THAT GIVES ANY BUG
    path: gisRoutes.management.service_number_type.list,
    component: ServiceNumberType,
    // restrictedFunction:
    //   portalFunctionalityConstants.management.service_number_type,
    // action: permissionTypeConst.EDIT,
    pccwglobal_only: true,
    routeType: "portal",
    type: "link",
    category: "management",
    name: phrasebook.numbers.number_information,
  },
  // {
  //   path: gisRoutes.management.order.submitOrder,
  //   component: SubmitOrder,
  //   routeType: "portal",
  //   restrictedFunction: portalFunctionalityConstants.management.order,
  //   action: permissionTypeConst.ADD,
  //   type: "add",
  //   name: phrasebook.common.add,
  // },
  {
    path: gisRoutes.download.list,
    component: Downloads,
    // restrictedFunction: portalFunctionalityConstants.notification.notification,
    // action: permissionTypeConst.LIST,
    routeType: "portal",
    // type: 'icon',
    category: "notification",
    name: phrasebook.headerlinks.downloads,
  },
  {
    path: gisRoutes.notification.notification.read,
    component: NotificationRead,
    routeType: "portal",
    // restrictedFunction: portalFunctionalityConstants.notification.notification,
    // action: permissionTypeConst.READ,
    type: "read",
    name: phrasebook.common.single_read,
  },
  {
    path: gisRoutes.notification.notification.list,
    component: Notifications,
    // restrictedFunction: portalFunctionalityConstants.notification.notification,
    // action: permissionTypeConst.LIST,
    routeType: "portal",
    // type: 'icon',
    category: "notification",
    name: phrasebook.notifications.notifications,
  },
  {
    path: gisRoutes.support.contacts,
    component: Contacts,
    // restrictedFunction: portalFunctionalityConstants.support.support,
    // action: permissionTypeConst.LIST,
    routeType: "portal",
    // type: 'icon',
    category: "support",
    name: phrasebook.headerlinks.contacts,
  },
  {
    path: gisRoutes.administration.configuration.edit,
    component: ConfigurationEdit,
    routeType: "portal",
    admin_only: true,
    category: "config",
    name: phrasebook.headerlinks.configuration,
  },
];
if (ORDER_ON && ORDER_ON == 'true') portalRoutes.push({
  path: gisRoutes.management.order.read,
  component: OrderShow,
  routeType: "portal",
  restrictedFunction: portalFunctionalityConstants.management.order,
  action: permissionTypeConst.LIST,
  name: phrasebook.common.show,
},
  {
    path: gisRoutes.management.order.add,
    component: OrderAddProcess,
    routeType: "portal",
    restrictedFunction: portalFunctionalityConstants.management.order,
    action: permissionTypeConst.ADD,
    type: "add",
    name: phrasebook.common.add,
  },
  {
    path: gisRoutes.management.order.edit,
    component: OrderEditProcess,
    routeType: "portal",
    restrictedFunction: portalFunctionalityConstants.management.order,
    action: permissionTypeConst.EDIT,
    type: "edit",
    name: phrasebook.common.edit,
  },

  // KC- disabling management>orders
  {
    path: gisRoutes.management.order.list,
    component: Orders,
    restrictedFunction: portalFunctionalityConstants.management.order,
    action: permissionTypeConst.LIST,
    routeType: "portal",
    type: "link",
    category: "management",
    name: phrasebook.headerlinks.orders,
  });
if (REPORT_ON && REPORT_ON == 'true') portalRoutes.push(
  {
    path: gisRoutes.report.summary_overview,
    component: SummaryOverview,
    // restrictedFunction: portalFunctionalityConstants.support.support,
    // action: permissionTypeConst.LIST,
    routeType: "portal",
    // type: 'icon',
    category: "report",
    name: phrasebook.reports.order_overview,
  },
  {
    path: gisRoutes.report.call_statistics,
    component: CallStatistics,
    // restrictedFunction: portalFunctionalityConstants.support.support,
    // action: permissionTypeConst.LIST,
    routeType: "portal",
    // pccwglobal_only: true,
    // type: 'icon',
    category: "report",
    name: phrasebook.headerlinks.call_statistics_daily,
  },
  {
    path: gisRoutes.report.call_statistics_h,
    component: CallStatisticsH,
    // restrictedFunction: portalFunctionalityConstants.support.support,
    // action: permissionTypeConst.LIST,
    routeType: "portal",
    // pccwglobal_only: true,
    // type: 'icon',
    category: "report",
    name: phrasebook.headerlinks.call_statistics_hourly,
  },
  {
    path: gisRoutes.report.call_records,
    component: CallRecords,
    // restrictedFunction: portalFunctionalityConstants.support.support,
    // action: permissionTypeConst.LIST,
    routeType: "portal",
    // pccwglobal_only: true,
    // type: 'icon',
    category: "report",
    name: phrasebook.reports.call_records,
  },
  {
    path: gisRoutes.management.invnumber.read,
    component: InvNumberShow,
    routeType: "portal",
    // restrictedFunction: portalFunctionalityConstants.management.invnumber,
    // action: permissionTypeConst.LIST,
    // pccwglobal_only: true,
    name: phrasebook.common.show,
  },
  {
    path: gisRoutes.management.invnumber.add,
    component: InvNumberAdd,
    routeType: "portal",
    restrictedFunction:
      portalFunctionalityConstants.management.invnumber,
    action: permissionTypeConst.ADD,
    pccwglobal_only: true,
    type: "add",
    name: phrasebook.common.add,
  },
  {
    path: gisRoutes.management.invnumber.bulk,
    component: InvNumberBulk,
    routeType: "portal",
    restrictedFunction:
      portalFunctionalityConstants.management.invnumber,
    action: permissionTypeConst.ADD,
    pccwglobal_only: true,
    type: "add",
    name: phrasebook.common.add,
  },

  {
    path: gisRoutes.management.invnumber.list,
    component: InvNumber,
    // restrictedFunction:
    //   portalFunctionalityConstants.management.invnumber,
    // action: permissionTypeConst.EDIT,
    // pccwglobal_only: true,
    routeType: "portal",
    type: "link",
    category: "report",
    name: phrasebook.headerlinks.invnumbers,
  },
  {
    path: gisRoutes.management.carrier.bulk,
    component: CarrierBulk,
    routeType: "portal",
    restrictedFunction:
      portalFunctionalityConstants.management.invnumber,
    action: permissionTypeConst.ADD,
    pccwglobal_only: true,
    type: "add",
    name: phrasebook.common.add,
  },
  {
    path: gisRoutes.management.carrier.list,
    component: Carrier,
    // restrictedFunction:
    //   portalFunctionalityConstants.management.invnumber,
    // action: permissionTypeConst.EDIT,
    pccwglobal_only: true,
    routeType: "portal",
    type: "link",
    category: "report",
    name: phrasebook.headerlinks.carriers,
  },
)
portalRoutes.push(...DashboardRoutes);
// portalRoutes.push(...PCCWGSalesRoutes);
// portalRoutes.push(...PCCWGProductRoutes);
// portalRoutes.push(...MasterRoutes);
// portalRoutes.push({ redirect: true, path: "/", to: gisRoutes.account.profile, type: 'redirect', name: phrasebook.common.redirect, routeType: 'portal' });
export default portalRoutes;
